import { getCookie } from '@/utils/cookie';

import { LAYOUT_COOKIE_NAME, LAYOUT_DETAILS } from './config';
import type { Layout } from './types';

// as other JS files are also using deviceType, will be converted to an enum later on
function isCompatibleLayout(layout: Layout, deviceType: string) {
    return LAYOUT_DETAILS[deviceType]?.layouts.includes(layout) || false;
}

function getLayoutCookie() {
    return getCookie(LAYOUT_COOKIE_NAME);
}

function setLayoutCookie(layout: Layout) {
    window.setCookie(LAYOUT_COOKIE_NAME, layout, 365);
}

function parseLayoutToNumber(layout: Layout): number {
    switch (layout) {
        case 'one-col':
            return 1;
        case 'two-col':
            return 2;
        case 'four-col':
            return 4;
        case 'six-col':
            return 6;
        case 'eight-col':
            return 8;

        default:
            return 4;
    }
}

export { getLayoutCookie, isCompatibleLayout, parseLayoutToNumber, setLayoutCookie };
